{
	"advancedDescription": "Edit multiple reference photos to create a more accurate AI Style.",
	"advancedSetup": "Advanced Setup",
	"expressDescription": "Quickly create your AI Style by editing a single reference photo.",
	"expressSetup": "Express Setup"
}
